import { join } from 'node:path';
import { getExtensionDir } from './definitions.js';

export function getDashboardPageExtensionsDir(projectFolder: string) {
  return join(getExtensionDir(projectFolder), 'dashboard', 'pages');
}

export function getDashboardPageExtensionPath(
  projectFolder: string,
  extensionPath: string
) {
  return join(getDashboardPageExtensionsDir(projectFolder), extensionPath);
}

export function getDashboardModalExtensionsDir(projectFolder: string) {
  return join(getExtensionDir(projectFolder), 'dashboard', 'modals');
}

export function getDashboardModalExtensionPath(
  projectFolder: string,
  extensionPath: string
) {
  return join(getDashboardModalExtensionsDir(projectFolder), extensionPath);
}

export function getDashboardPluginExtensionsDir(projectFolder: string) {
  return join(getExtensionDir(projectFolder), 'dashboard', 'plugins');
}

export function getDashboardPluginExtensionPath(
  projectFolder: string,
  extensionPath: string
) {
  return join(getDashboardPluginExtensionsDir(projectFolder), extensionPath);
}

export function getDashboardMenuPluginExtensionsDir(projectFolder: string) {
  return join(getExtensionDir(projectFolder), 'dashboard', 'menu-plugins');
}

export function getDashboardMenuPluginExtensionPath(
  projectFolder: string,
  extensionPath: string
) {
  return join(
    getDashboardMenuPluginExtensionsDir(projectFolder),
    extensionPath
  );
}
